import { render, staticRenderFns } from "./AllItems.vue?vue&type=template&id=0e1587bd&scoped=true&"
import script from "./AllItems.vue?vue&type=script&lang=js&"
export * from "./AllItems.vue?vue&type=script&lang=js&"
import style0 from "./AllItems.vue?vue&type=style&index=0&id=0e1587bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1587bd",
  null
  
)

export default component.exports